import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    confirm: 'Delete',
    description:
      'Any reference to this quote will be deleted and you won’t be able to access it anymore.',
    errorMessage:
      'An error occurred while deleting your quote. Please try again in a few minutes and don’t hesitate to contact us if the error remains.',
    successMessage: 'Your quote has been successfully deleted!',
    title: 'Are you sure you want to delete this quote?',
  },
  fr: {
    confirm: 'Supprimer',
    description:
      'Toutes références au devis seront supprimées et vous ne pourrez plus y accéder.',
    errorMessage:
      'Une erreur est survenue lors la suppression de votre devis. Essayez à nouveau dans quelques minutes et n’hésitez pas à nous contacter si le problème persiste.',
    successMessage: 'Votre devis a bien été supprimé\xA0!',
    title: 'Êtes-vous sûr·e de vouloir supprimer ce devis\xA0?',
  },
} as const);
